import React from 'react';
import css from './css.module.less';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import { useSelector, useDispatch } from 'react-redux';
import {
  updatePreviewSize,
  currentSelectedSize,
} from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/slice';
// import Clickable from 'src/components/ClickableContainer';

const Tab = (props) => {
  const { selected, children, style, onClick } = props;
  return (
    <div
      style={style}
      className={`${css.tab} ${selected ? css.selected : ''}`}
      onClick={onClick}>
      {children}
    </div>
  );
};

const SizeContainer = (props) => {
  const {
    children, //currentKey
  } = props;
  const selected = useSelector(currentSelectedSize());
  const d = useDispatch();
  const width = sizeDict[selected];
  return (
    <div className={css.container}>
      <div className={css.tagContainer}>
        <Tab
          selected={EPreviewSize.WIDE === selected}
          onClick={() => {
            d(updatePreviewSize(EPreviewSize.WIDE));
          }}>
          Responsive PC
        </Tab>
        {/* <Tab
          onClick={() => {
            d(updatePreviewSize(EPreviewSize.NARROW));
          }}
          selected={EPreviewSize.NARROW === selected}
          style={{ minWidth: 220 }}>
          Responsive PC (Narrow)
        </Tab> */}
        <Tab
          onClick={() => {
            d(updatePreviewSize(EPreviewSize.TABLET));
          }}
          selected={EPreviewSize.TABLET === selected}>
          Responsive Tablet
        </Tab>
        <Tab
          onClick={() => {
            d(updatePreviewSize(EPreviewSize.MOBILE));
          }}
          selected={EPreviewSize.MOBILE === selected}>
          Responsive Mobile
        </Tab>
      </div>
      <div className={css.previewContainer}>
        <div className={css.previewInnerContainer} style={{ width }}>
          {children}
          {/* <PreviewContainer size={selected}>{children}</PreviewContainer> */}
        </div>
      </div>
    </div>
  );
};
export default SizeContainer;

const sizeDict = {
  [EPreviewSize.WIDE]: 1440,
  [EPreviewSize.NARROW]: 1024,
  [EPreviewSize.TABLET]: 726,
  [EPreviewSize.MOBILE]: 320,
};

// const PreviewContainer = (props) => {
//   const { size, children } = props;
//   const width = sizeDict[size];
//   return <div style={{ width }}>{children}</div>;
// };
